import 'lazysizes/plugins/rias/ls.rias';
import 'lazysizes';

const sizes = [
  30, 60, 90, 120, 150, 180, 210, 240, 270, 300, 330,
  410, 490, 570, 650, 730, 810, 890, 970,
  1050, 1290, 1530, 1770,
  2090, 2410, 2730,
];

document.addEventListener('lazyriasmodifyoptions', (event) => {
  if (!(event.target instanceof HTMLElement)) {
    return;
  }

  const width = parseInt(event.target.dataset.maxWidth, 10);
  const height = parseInt(event.target.dataset.maxHeight, 10);
  const aspect = {
    0: event.detail.aspectratio,
  };

  if (event.detail.isPicture) {
    const sources = event.target.parentElement.querySelectorAll('source');

    sources.forEach((source) => {
      aspect[source.media.replace(/[^0-9]/g, '')] = parseFloat(source.dataset.aspectratio);
    });
  }

  const aspectKeys = Object.keys(aspect).reverse();
  const widths = [];

  sizes.forEach((size) => {
    const aspectKey = aspectKeys.find((breakpoint) => size >= parseInt(breakpoint, 10));
    const currentAspect = aspect[aspectKey];

    if (currentAspect !== false) {
      if (size <= width && size / currentAspect <= height) {
        widths.push(size);
      }
    } else if (size <= width) {
      widths.push(size);
    }
  });

  event.detail.widths = widths;
});
